/**
 * Skills Engine computation_version. Bump only when the deterministic
 * mapping from (evidence, catalogue, weights) to InferredSkill /
 * ProbabilityIndicator changes. Any bump invalidates stored
 * computation hashes and requires a new golden fixture.
 */
export const SKILLS_ENGINE_VERSION = "1.0.0";

/** Version of the bundled open-standards taxonomy seed (ESCO/ISCO/O*NET refs). */
export const SKILLS_TAXONOMY_VERSION = "esco-1.2.0-seed.1";
